module.exports = __webpack_public_path__ + "static/media/common_dad_default.e65e7780.png";